export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Техникалық қолдау сұрауы"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["бастап"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Чат"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Хабарлама қосу"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Файлдар"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бір немесе бірнеше файлды жүктей аласыз. Файлдың максималды өлшемі - 10 Мб."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Хабарлама мәтіні"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жіберу"])}
}